import { Box, Text } from '@wix/design-system';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';
import classNames from 'classnames';
import s from '../Header.scss';

export const DefaultPromotionalMessage = () => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  return (
    <Box align="center" width="100%">
      <Text className={classNames(s.withDash, s.semiBold)}>
        {t('studio_package_picker.header.strip.money_back')}
      </Text>
    </Box>
  );
};
